import Utils from '../../common/Utils';

/**
 * CharacterInfo Template
 * @category main
*/
class CharacterInfoTempl {
    /**
     * CharacterInfo Templ
     * @param  {Object} _d={}
     */
    static getTempl(_d={}) {

        let templ = '';
        if(_d.result == 'SUCCESS'){
            templ = `
            <ul class="character-info-list">
                <li class="character-info-item" id="charInfoMain">${CharacterInfoTempl.char(_d.data)}</li>
                <li class="character-info-item" id="charInfoSales">${CharacterInfoTempl.sales(_d.data)}</li>
                <li class="character-info-item friends-info" id="charInfoClan">${CharacterInfoTempl.clan(_d.data)}</li>
                <li class="character-info-item friends-info" id="charInfoFriends">${CharacterInfoTempl.friends(_d.data)}</li>
            </ul>`;
        }

        if(_d.result == 'BOSS_CHARACTER_NOT_FOUND'){
            templ = this.noMainChar();
        }

        return templ;
    }

    /**
     * 캐릭터 템플릿
     */
    static char(_d){
        const createDOri = new Date(_d.createDate);
        const createD = `${createDOri.getFullYear()}. ${Utils.leadingZeros(createDOri.getMonth()+1, 2)}. ${Utils.leadingZeros(createDOri.getDate(), 2)}`;
        const logoutDOri = new Date(_d.recentLogoutDate);
        const logoutD = `${logoutDOri.getFullYear()}. ${Utils.leadingZeros(logoutDOri.getMonth()+1, 2)}. ${Utils.leadingZeros(logoutDOri.getDate(), 2)} ${Utils.leadingZeros(logoutDOri.getHours(), 2)}:${Utils.leadingZeros(logoutDOri.getMinutes(), 2)}:${Utils.leadingZeros(logoutDOri.getSeconds(), 2)}`;
        const characterUrl = `/character/${_d.serverId}/${_d.characterId}/myboard`;
        const imgUrl = CharacterInfoTempl.mainCharImg(_d);
        const chatlogUrl = `/character/${_d.serverId}/${_d.characterId}/chatlog/index#!/1`;

        return `
        <h3 class="item-title">캐릭터</h3>
        <div class="character-info-inner">
            <div class="item-main-info">
                <a href="${characterUrl}"><span class="item-thumb"><img src="${imgUrl}" alt=""></span></a>
                <div class="main-text-wrap">
                    <span class="main-text"><span>우편: </span><em>${_d.postCount}</em><em class="alarm-tooltip">새로운 우편이 ${_d.postCount>0?'있':'없'}습니다.</em></span>
                    <span class="main-text">혈맹: ${_d.clanName || '가입된 혈맹이 없습니다.' }</span>
                </div>
            </div>
            <div class="item-sub-info">
                <span class="sub-text">생성일자: ${createD}</span>
                <span class="sub-text">최근접속: ${logoutD}</span>
            </div>
        </div>`;
    }

    /**
     * 판매대행 템플릿
     */
    static sales(_d={}){
        const list = CharacterInfoTempl.salesItemList(_d.commissions.onSales, 1);

        return `
        <h3 class="item-title">판매대행</h3>
        <div class="info-tab-wrap">
            <button type="button" class="info-tab is-active" data-status="progress" id="sale-progress">진행</button>
            <button type="button" class="info-tab" data-status="complete" id="sale-complete">완료</button>
        </div>
        <div class="character-info-inner">
            <ul class="item-info-list has-no-thumb">${list}</ul>
        </div>`;
    }

    static salesItemList(_d={}, _type=1){
        if(_d.length<1){
            return CharacterInfoTempl.hasNoItem(`판매대행${_type===1?` 중인`:`이 완료된`} 아이템이 없습니다.`);
        }

        const statusInfo ={
            'SALE':{ clsName: 'on-sale', title: '판매중' },
            'SOLD':{ clsName: 'sold', title: '판매완료' },
            'RETURNED':{ clsName: 'returned', title: '반송완료' }
        };

        return _d.map(_it=>{
            let infoText = '';
            switch (_it.status) {
                case 'SALE':
                    infoText = _it.item.name;
                    break;
                case 'SOLD':
                    infoText = _it.message;
                    break;
                case 'RETURNED':
                    infoText = _it.item.name;
                    break;
              }

            return `
            <li class="info-item">
                <span class="info-text">${infoText}</span>
                <em class="status-text is-${statusInfo[_it.status].clsName}">${statusInfo[_it.status].title}</em>
            </li>`;
        }).join('');
    }

    /**
     * 혈맹 템플릿
     */
    static clan(_d={}){
        let list = '';
        if(!_d.clanMembers || _d.clanMembers.length<1){
            list = CharacterInfoTempl.hasNoItem(`가입된 혈맹이 없습니다. 게임 내에서 혈맹에 가입하여 정보를 받아보세요.`);
        } else {
            list = _d.clanMembers.map( _it =>  CharacterInfoTempl.charItem(_it) ).join('');
        }

        return `<h3 class="item-title">혈맹</h3><div class="character-info-inner"><ul class="item-info-list">${list}</ul></div>`;
    }

    /**
     * 친구 템플릿
     */
    static friends(_d={}){
        let list = _d.friendMembers.map( _it =>  CharacterInfoTempl.charItem(_it) ).join('');
        if(_d.friendMembers.length<1){
            list = CharacterInfoTempl.hasNoItem(`등록된 친구가 없습니다. 게임 내 친구를 등록하여 정보를 받아보세요.`);
        }
        return `<h3 class="item-title">친구</h3><div class="character-info-inner"><ul class="item-info-list">${list}</ul></div>`;
    }

    /**
     * 대표 캐릭터 미설정 템플릿
     */
    static noMainChar(){
        return `
        <div class="character-info-notice">
            <div class="notice-inner">
                <strong class="notice-title">대표캐릭터 설정</strong>
                <span class="notice-text">대표캐릭터를 설정하면 더욱 편리하게 홈페이지를 이용할 수 있습니다.</span>
                <a href="#" class="notice-link"><span class="blind">대표캐릭터 설정하러가기</span></a>
            </div>
        </div>`;
    }

    static hasNoItem(_message){
        return `<li class="is-show notice-wrap"><span class="notice-text">${_message}</span></li>`;
    }

    static charItem(_it={}){
        const characterUrl = `/character/${_it.serverId}/${_it.characterId}/myboard`;
        return `
        <li class="info-item${_it.login?'': ' is-off'}">
            <a href="${characterUrl}" class="info-link">
                <span class="thumb-wrap"><img src="${CharacterInfoTempl.mainCharImg(_it)}" alt=""></span>
                <span class="info-text">${_it.name}</span>    
            </a>            
            <span class="info-inner">
                <em class="status-text">${_it.login?'on':'off'}</em>
            </span>
        </li>`;
         /**
         * 선물하기 버튼이 있는 경우의 info-innter
            <span class="info-inner">
                ${_it.own ? ``:`<button class="btn-gift flag" data-charname="${_it.name}"><span class="flag-gift">선물</span></button>`}
                <em class="status-text">${_it.login?'on':'off'}</em>
            </span>
         */
    }

    /**
     * 캐릭터 대표 이미지
     * 각성 서버 : lineage2Awakening_[종족번호][성별번호].jpg
     * 본서버 : lineage2_[종족번호][성별번호].jpg
     * @example
     * https://assets.playnccdn.com/resource/lineage2/profile/lineage2_00.png
     */
    static mainCharImg(_it={}){
        return `https://assets.playnccdn.com/resource/lineage2/profile/${_it.serverType}_${_it.race}${_it.gender}.png`;
    }




} // end of class

export default CharacterInfoTempl;